import React from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Link
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/App.css';
import Header from "./Header/";
import Main from "./Main/";
import Categories from "./Categories";
import Footer from "./Footer/";
import reducers from '../reducers';
import styled from 'styled-components';

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

function App() {


	function handleUpdate() {
		console.log('here');

	}

	return (
		<Provider store={createStoreWithMiddleware(reducers)}>
			<Router>
				<Header />
				<Switch>
					<Route path='/categories/:id' render={(props) => <Categories {...props} />} />
					<Route path="/categories">
						<Categories />
					</Route>
					<Route path="/">
						<Main />
					</Route>
				</Switch>
				<Footer />
			</Router>
		</Provider>
	);
}

export default App;
